import styled, { useTheme } from 'styled-components'
import AnimatedImage from 'components/AnimatedImage'
import { device } from '../../breakpoints'
import { Button } from 'styles'
import UserVote from 'components/UserVote'
import MinergieBadge from 'components/MinergieBadge'
import { Waypoint } from 'react-waypoint'
import {
  useEffect,
  useRef,
  createRef,
  useContext,
  useState,
  useCallback,
} from 'react'
import { BsArrowRightShort } from 'react-icons/bs'
import { YearContext } from 'contexts'
import { getCandidatImage } from '../../utils/getCandidatImage'
import { hasVoted } from '../../utils/voteStorageKey'

const hasMinergieLabel = (label?: string) =>
  typeof label === 'string' && label.toLowerCase().includes('minergie')

const ProjectsList = ({
  projects,
  handleCategoryWaypoint,
  handleClick,
  scrollTo,
  handleCategories,
}: {
  projects: any[]
  handleCategoryWaypoint: (category: string | null) => void
  handleClick: (id: string) => void
  scrollTo?: string | null
  handleCategories: (categories: string[]) => void
}) => {
  const theme = useTheme()
  const year = useContext(YearContext)
  const [categories, setCategories] = useState<any[]>([])
  const [votedCategories, setVotedCategories] = useState<string[]>([])
  const isMobile = window.innerWidth < 768

  const categoryRefs = useRef<
    { name: string; ref: React.RefObject<HTMLDivElement> | null }[]
  >([])

  useEffect(() => {
    categoryRefs.current = categories.map((category, i) => ({
      name: category.name,
      ref: categoryRefs.current[i]?.ref || createRef(),
    }))
  }, [categories])

  useEffect(() => {
    const res = [...new Set(projects.map((project) => project.category))]
      .sort((a, b) => 0.5 - Math.random())
      .map((category) => ({ name: category }))
    handleCategories(res.map((category) => category.name))

    setCategories(res)

    projects.sort((a, b) => {
      // if (isNaN(a.rank) && isNaN(b.rank)) return 0
      // if (isNaN(a.rank)) return 1
      // if (isNaN(b.rank)) return -1
      // return a.rank - b.rank
      return 0.5 - Math.random()
    })
  }, [projects])

  const onVoted = useCallback((category: string) => {
    setVotedCategories((prev) =>
      prev.includes(category) ? prev : [...prev, category]
    )
  }, [])

  useEffect(() => {
    const categoryRef = categoryRefs.current.find((c) => c.name === scrollTo)
    if (categoryRef?.ref?.current) {
      categoryRef.ref.current.scrollIntoView({ behavior: 'smooth' })
    }
  }, [scrollTo])

  return (
    <Container>
      {projects.filter((project) => project.rank === 1).length > 0 && (
        <CategoryLaureatsContainer key={'laureats'}>
          <CategoryTitleContainer>
            <CategoryLabel>Palmarès</CategoryLabel>
            <CategoryTitle>Les lauréats</CategoryTitle>
          </CategoryTitleContainer>

          <CategoryContent>
            {projects
              .filter((project) => project.rank === 1 || project.prix)
              .map((project) => (
                <ProjectContainer key={`project-${project.id}`}>
                  <ImagesContainer onClick={() => handleClick(project.id)}>
                    {new Array(1).fill(0).map((_, index) => (
                      <AnimatedImage
                        key={index}
                        text={project.title}
                        src={getCandidatImage(year, project.number, index, 's')}
                        strength={0.5}
                      />
                    ))}
                    {hasMinergieLabel(project.label) && (
                      <MinergieBadge label={project.label} />
                    )}
                  </ImagesContainer>
                  <TextContainer>
                    <div>
                      <RankContainer>
                        {project.rank === 1 && <Rank rank={1}>Lauréat</Rank>}
                        {project.prix && <Rank rank={1}>{project.prix}</Rank>}
                      </RankContainer>
                      <Title>{project.title}</Title>
                      <Infos>
                        <Label>Catégorie</Label>
                        {(project.rank === 1 || project.prix) && (
                          <Value>{project.category}</Value>
                        )}
                        {/* {project.prix && <Value>{project.prix}</Value>} */}
                        <Label>Architecte</Label>
                        <Value>{project.architect}</Value>
                        {project.label && (
                          <>
                            <Label>Label</Label>
                            <Value>{project.label}</Value>
                          </>
                        )}
                        {/* <Label>Maître d’ouvrage</Label>
                            <Value>{project.client}</Value> */}
                        {/* {project.generalContractor.length > 3 && (
                              <>
                                <Label>Entreprise générale</Label>
                                <Value>{project.generalContractor}</Value>
                              </>
                            )} */}
                        {/* <Label>Adresse</Label>
                            <Value>{project.location}</Value> */}
                        {/* <Label>Vote du public</Label>
                          <Value>
                            <UserVote
                              starDimension='20px'
                              starEmptyColor='#00000066'
                              starHoverColor='#ffffff'
                              starRatedColor={theme.colorTextInverted}
                              tippId={project.id}
                              handleUpdateRatingCount={(count: number) => {}}
                            />
                          </Value> */}
                      </Infos>
                    </div>
                  </TextContainer>
                  <Actions onClick={() => handleClick(project.id)}>
                    <ActionBtn>Voir le projet</ActionBtn>
                  </Actions>
                </ProjectContainer>
              ))}
          </CategoryContent>
        </CategoryLaureatsContainer>
      )}

      {categories.map((category, categoryIndex) => (
        <CategoryContainer
          key={categoryIndex}
          ref={categoryRefs.current[categoryIndex]?.ref}
        >
          <CategoryTitleContainer>
            <CategoryLabel>Catégorie</CategoryLabel>
            <CategoryTitle>{category.name}</CategoryTitle>
          </CategoryTitleContainer>
          <Waypoint
            bottomOffset={'50%'}
            scrollableAncestor='window'
            onEnter={() => {
              handleCategoryWaypoint(category.name)
            }}
            onLeave={(e) => {
              e.currentPosition === 'below' &&
                categoryIndex === 0 &&
                handleCategoryWaypoint(null)
            }}
          >
            <CategoryContent>
              {projects
                .filter(
                  (project) => project.category === category.name // && project.published === true
                )
                .map((project) => (
                  <ProjectContainer key={`project-${project.id}`}>
                    <ImagesContainer onClick={() => handleClick(project.id)}>
                      {new Array(1).fill(0).map((_, index) => (
                        <AnimatedImage
                          key={index}
                          text={project.title}
                          src={getCandidatImage(year, project.number, index, 's')}
                          strength={0.5}
                        />
                      ))}
                      {hasMinergieLabel(project.label) && (
                        <MinergieBadge label={project.label} />
                      )}
                    </ImagesContainer>
                    <TextContainer>
                      <div>
                        <RankContainer>
                          {project.rank === 1 && <Rank rank={1}>Lauréat</Rank>}
                          {project.rank === 2 && <Rank rank={1}>Nominé</Rank>}
                          {project.rank === 3 && <Rank rank={1}>Nominé</Rank>}
                          {project.prix && <Rank rank={1}>{project.prix}</Rank>}
                        </RankContainer>
                        <Title>{project.title}</Title>
                        <Infos>
                          <Label>Architecte</Label>
                          <Value>{project.architect}</Value>
                          {/* <Label>Maître d’ouvrage</Label>
                            <Value>{project.client}</Value> */}
                          {/* {project.generalContractor.length > 3 && (
                              <>
                                <Label>Entreprise générale</Label>
                                <Value>{project.generalContractor}</Value>
                              </>
                            )} */}
                          {/* <Label>Adresse</Label>
                            <Value>{project.location}</Value> */}
                          {project.label && (
                            <>
                              <Label>Label</Label>
                              <Value>{project.label}</Value>
                            </>
                          )}
                          <Label>Vote du public</Label>
                          <Value>
                            <UserVote
                              disabled={
                                true
                                // hasVoted(year, project.category) ||
                                // votedCategories.includes(project.category)
                              }
                              starDimension={isMobile ? '30px' : '20px'}
                              starEmptyColor='#ffffff44'
                              starHoverColor='#ffffff'
                              starRatedColor={theme.colorTextInverted}
                              tippId={project.id}
                              category={project.category}
                              handleUpdateRatingCount={() => {}}
                              onVoted={onVoted}
                            />
                          </Value>
                        </Infos>
                      </div>
                    </TextContainer>
                    <Actions onClick={() => handleClick(project.id)}>
                      <ActionBtn>Voir le projet</ActionBtn>
                    </Actions>
                  </ProjectContainer>
                ))}
            </CategoryContent>
          </Waypoint>
        </CategoryContainer>
      ))}
    </Container>
  )
}

const Container = styled.div`
  margin: 0 auto;
  width: 100%;
`

const Title = styled.div`
  font-size: 1.5em;
  line-height: 1;
  margin-bottom: 22px;

  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
    font-size: 1.5em;
  }

  @media ${device.tablet}, @media ${device.laptop} {
    font-size: 1.5em;
  }
`

const CategoryContainer = styled.div`
  padding-top: 45px;
  border-top: 1px solid ${({ theme }) => theme.colorLine};

  &:first-child {
    border: 0;
  }
`

const CategoryLaureatsContainer = styled(CategoryContainer)`
  background-color: #222222;
  margin-top: 40px;
  padding-top: 50px;
`

const CategoryContent = styled.div`
  display: grid;
  grid-gap: 15px;
  max-width: 1400px;
  padding: 0 75px;
  margin: 0 auto;

  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
    grid-template-columns: repeat(1, 1fr);
    padding: 0 15px;
  }

  @media ${device.tablet} {
    grid-template-columns: repeat(2, 1fr);
    padding: 0 15px;
  }

  @media ${device.laptop} {
    grid-template-columns: repeat(3, 1fr);
    padding: 0 75px;
  }

  @media ${device.laptopL},
    @media ${device.desktop},
    @media ${device.desktopL} {
    grid-template-columns: repeat(4, 1fr);
    padding: 0 75px;
  }
`

const CategoryLabel = styled.div`
  display: inline-block;
  font-size: 0.5em;
  line-height: 1;
  padding: 65px;
  padding-bottom: 15px;
  padding-top: 65px;
  text-align: center;
  color: ${({ theme }) => theme.colorGreyDark};

  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
    font-size: 0.75em;
    padding-top: 20px;
  }

  @media ${device.tablet}, @media ${device.laptop} {
    font-size: 0.5em;
    padding-top: 65px;
  }
`

const CategoryTitleContainer = styled.div`
  text-align: center;
  color: ${({ theme }) => theme.colorTextInverted};
  font-size: clamp(2.125rem, 1.557rem + 2vw, 4rem);
`

const CategoryTitle = styled.div`
  font-size: 1.5em;
  line-height: 1;
  padding: 65px;
  padding-top: 0;

  &:after {
    content: '';
    display: block;
    width: 60px;
    height: 2px;
    margin: 0 auto;
    background-color: ${({ theme }) => theme.colorTextInverted};
    margin-top: 25px;
    opacity: 0.5;
  }

  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
    font-size: 1.5em;
  }

  @media ${device.tablet}, @media ${device.laptop} {
    font-size: 1.5em;
  }
`

const Rank = styled.div<{ rank: number }>`
  color: ${({ theme }) => theme.colorText};
  background-color: white;
  display: inline-block;
  font-size: 0.65em;
  padding: 7px 10px;
  border-radius: 50px;

  margin-right: 0.5em;
  margin-bottom: 0.5em;

  &:last-child {
    margin-right: 0;
  }
`

const RankContainer = styled.div`
  margin-bottom: 0.5em;
  position: absolute;
  top: 10px;
  left: 10px;
  z-index: 1;
`

const ProjectContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  color: white;
  border: 1px solid #44444477;
  background-color: #33333344;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  border-radius: 16px;
  position: relative;

  width: 100%;
  margin-bottom: 45px;
  // border-radius: 4px;
  overflow: hidden;
  // box-shadow: 0 0 8px rgba(0, 0, 0, 0.085), 0 2px 4px rgba(0, 0, 0, 0.05);
`

const TextContainer = styled.div`
  grid-column: 1 / 13;
  padding: 30px;
  padding-bottom: 0;
  color: ${({ theme }) => theme.colorTextInverted};
  line-height: 1.2;
  -webkit-font-smoothing: antialiased;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-self: start;
  flex: 1;
  width: 100%;
  box-sizing: border-box;

  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
    grid-column: 1 / 13;
    padding: 15px;
    padding-bottom: 0;
  }

  @media ${device.tablet}, @media ${device.laptop} {
    grid-column: 1 / 13;
    padding: 30px;
    padding-bottom: 0;
  }
`

const Infos = styled.div`
  display: grid;
  grid-template-columns: 0.65fr 1fr;
  // padding-bottom: 15px;
  font-size: 0.85em;

  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
    font-size: 0.85em;
  }

  @media ${device.tablet}, @media ${device.laptop} {
    font-size: 0.85em;
  }
`

const Label = styled.div`
  padding-top: 12px;
  padding-bottom: 12px;
  border-top: 1px solid ${({ theme }) => theme.colorLine};
  padding-right: 7px;
  font-size: 0.85em;
  color: ${({ theme }) => theme.colorGreyDark};
`

const Value = styled.div`
  padding-top: 12px;
  padding-bottom: 12px;
  border-top: 1px solid ${({ theme }) => theme.colorLine};
  padding-left: 8px;
`

const Actions = styled.div`
  display: flex;
  justify-content: center;
  padding-bottom: 30px;
  margin-top: 15px;
`

const ActionBtn = styled.div`
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #333333;
  box-sizing: border-box;
  font-size: 0.75em;
  font-weight: 600;
  transition: opacity 0.2s;
  -webkit-font-smoothing: antialiased;
  border-radius: 50px;
  padding: 3px 20px;

  background-color: #e9e9e9;

  &:hover {
    opacity: 0.65;
  }
`

const ImagesContainer = styled.div`
  width: 100%;
  grid-column: 1 / 713;
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  grid-template-rows: repeat(6, 1fr);
  grid-gap: 15px;
  overflow: hidden;
  align-self: start;
  cursor: pointer;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 40%;
    pointer-events: none;
    background: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0.45) 0%,
      rgba(0, 0, 0, 0) 100%
    );
  }

  div:nth-child(1) {
    grid-column: 1 / 13;
    grid-row: 1 / 13;
  }

  @media ${device.mobileS}, @media ${device.mobileM}, @media ${device.mobileL} {
    grid-column: 1 / 13;
  }

  @media ${device.tablet}, @media ${device.laptop} {
    grid-column: 1 / 13;
  }
`

export default ProjectsList
